import { useMemo } from 'react'
import useSWRImmutable from 'swr/immutable'
import { Schemas } from '~/api/gen'
import { SeeMoreButton } from '~/components/elements/SeeMoreButton'
import { Coordinate3ColumnList } from '~/components/modules/CoordinatesList/Coordinate3ColumnList/Coordinate3ColumnList'
import { fetchSearchCoordinates } from '~/features/shared/search/utils/fetchSearchCoordinates'
import { getSearchCoordinatesKey } from '~/features/shared/search/utils/getSearchCoordinatesKey'
import { useIsDesktop } from '~/hooks/useMediaQuery'
import { shuffle } from '~/lib/shuffle'
import { sendGtmEvPopularityCoordinateAppButton } from '../lib/gtmEvent'

type Props = {
  coordinates: Schemas.coordinate_search_v2[]
  onClickAppButton: () => void
}

export const PopularityCoordinateView: React.FC<Props> = ({
  coordinates,
  onClickAppButton,
}) => (
  <div className="pb-[9px] pt-2 xl:pb-0 xl:pt-[22px]">
    <h2 className="pl-4 text-[14px] font-bold leading-[1.4] xl:pl-0">
      注目のコーディネート
    </h2>
    <div className="pt-3">
      <Coordinate3ColumnList coordinates={coordinates} />
    </div>
    <div className="flex justify-center pt-2 xl:hidden">
      <a
        className="px-[5px] py-[10px] text-[16px] text-blue-500"
        href="wear2020://wear.jp/search_result/coordinate/?sort_type=1"
        onClick={onClickAppButton}
      >
        アプリでもっと見る
      </a>
    </div>
    <div className="hidden xl:flex xl:justify-end xl:pt-7">
      <div className="xl:w-[100px]">
        <SeeMoreButton
          href="/coordinate/"
          aria-label="注目のコーディネートをもっと見る"
        />
      </div>
    </div>
  </div>
)

export const PopularityCoordinate: React.FC = () => {
  const { data } = useSWRImmutable(
    getSearchCoordinatesKey({ sort_type: 'popularity' }),
    fetchSearchCoordinates
  )
  const coordinates = useMemo(
    () => shuffle(data?.coordinates ?? []),
    [data?.coordinates]
  )
  const isDesktop = useIsDesktop()
  const DISPLAY_COUNT_FOR_DESKTOP = 6

  return (
    <PopularityCoordinateView
      coordinates={
        isDesktop
          ? coordinates.slice(0, DISPLAY_COUNT_FOR_DESKTOP)
          : coordinates
      }
      onClickAppButton={sendGtmEvPopularityCoordinateAppButton}
    />
  )
}
